/* eslint-disable jsx-a11y/anchor-is-valid */
//*Importing libraries from react
import React from "react";

export function Alert(props: any) {
  return (
    <div>
      {props.show_warning && (
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 5400,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            padding: ".625em",
            overflowX: "hidden",
            overflowY: "auto",
          }}
          tabIndex={0}
        >
          <div
            className="sweet-alert "
            style={{
              display: "flex",
              overflow: "hidden",
              backgroundColor: "rgb(255, 255, 255)",
              outline: "none",
              width: "32em",
              padding: "1.25rem",
              margin: "auto",
              borderRadius: ".3125em",
              textAlign: "center",
              position: "relative",
              flexDirection: "column",
              justifyContent: "center",
              maxWidth: "100%",
              zIndex: 5600,
              animation: "showSweetAlert 300ms",
            }}
            tabIndex={0}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                borderWidth: "4px",
                borderStyle: "solid",
                borderColor: "#eea236",
                borderRadius: "50%",
                margin: "20px auto",
                position: "relative",
                boxSizing: "content-box",
                animation: "pulseWarning 0.75s infinite alternate",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  width: "5px",
                  height: "47px",
                  left: "50%",
                  top: "10px",
                  borderRadius: "2px",
                  marginLeft: "-2px",
                  backgroundColor: "rgb(240, 173, 78)",
                  animation: "pulseWarningIns 0.75s infinite alternate",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  marginLeft: "-3px",
                  left: "50%",
                  bottom: "10px",
                  backgroundColor: "rgb(240, 173, 78)",
                  animation: "pulseWarningIns 0.75s infinite alternate",
                }}
              />
            </div>
            <h2
              style={{
                position: "relative",
                maxWidth: "100%",
                margin: "0px 0px .4em",
                padding: 0,
                fontSize: "1.875em",
                fontWeight: 600,
                textAlign: "center",
                textTransform: "none",
                wordWrap: "break-word",
              }}
            >
              {props.title}
            </h2>
            <div
              data-testid="delete-message"
              style={{
                zIndex: 1,
                justifyContent: "center",
                margin: 0,
                padding: 0,
                fontSize: "1.125em",
                fontWeight: 300,
                lineHeight: "normal",
                textAlign: "center",
                wordWrap: "break-word",
              }}
            >
              {props.text}
            </div>
            <p
              style={{
                display: "flex",
                zIndex: 1,
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                margin: "1.25em auto 0px",
              }}
            >
              <a
                className="btn btn-lg btn-danger "
                href="#"
                style={{ marginRight: "8px" }}
                onClick={(e) => {
                  e.preventDefault();
                  if (props.onCancel) props.onCancel();
                }}
              >
                Cancelar
              </a>
              <a
                data-testid="confirm-delete-button"
                className="btn btn-lg btn-success  "
                href="#"
                style={{
                  marginRight: "8px",
                  borderColor: "#4cae4c",
                  boxShadow:
                    "inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(76, 174, 76, 0.6)",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  if (props.onConfirm) props.onConfirm();
                }}
              >
                Sim, desejo apagar
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}